import * as moment from 'moment-timezone';

class DateFormatter {

    public toTimezoneFormatted(stamp: string, timezone: string, format: string){
        const utc = moment.tz(stamp, 'UTC'); // Force UTC to prevnt the browser defaulting to your local timezone
        const convertToDate = utc.tz(timezone).format(format);
        return convertToDate;
    }

    public toFormatted(stamp: string, format: string){
        return moment(stamp).format(format);
    }
}

const dateFormatter = new DateFormatter();
export { dateFormatter };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/utils/date-formatter.ts